import { render } from "./TelasView.vue?vue&type=template&id=6b9aca54"
import script from "./TelasView.vue?vue&type=script&lang=js"
export * from "./TelasView.vue?vue&type=script&lang=js"

import "./TelasView.vue?vue&type=style&index=0&id=6b9aca54&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__